import React from 'react';

import { centsToDollarString } from 'utils';

import { useUIContext } from 'state/ui';

export interface ICurrencyProps {
  amount?: number;
  prefix?: string;
  suffix?: string;
  hideCurrencySymbol?: boolean;
  id?: string;
  className?: any;
}

export const Currency = ({
  amount = 0,
  prefix = '',
  suffix = '',
  hideCurrencySymbol = false,
  className
}: ICurrencyProps) => {
  const { formatCurrencyForLocale } = useUIContext();
  const formattedAmount = hideCurrencySymbol
    ? centsToDollarString(amount)
    : formatCurrencyForLocale(amount);

  return (
    <div aria-label={`${prefix}${formattedAmount}${suffix}`} className={className}>
      {prefix}
      {formattedAmount}
      {suffix}
    </div>
  );
};

export default Currency;
